var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"main-wrapper"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{staticClass:"m-no-padding",attrs:{"md":18,"sm":18,"xs":24}},[_c('MemberListView')],1),_c('el-col',{attrs:{"md":6,"sm":6,"xs":24}},[_c('right-sider-bar')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }